import { Controller, useFormContext } from 'react-hook-form'

import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import { castError } from 'modules/expenses/components/expenses/Detail/_newForm/castError'
import withCustomizationFields, {
  WithCustomizationFieldsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import withFieldPermissions, {
  WithFieldPermissionsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

const FIELD_NAME = 'internalReference'

const InternalReferenceField = ({
  isFieldMandatory,
  isFieldReadOnly,
}: WithCustomizationFieldsProps & WithFieldPermissionsProps) => {
  const {
    control,
    formState: { errors },
    watch,
  } = useFormContext()

  // NOTE: This component is intentionally subscribed to its own value using watch().
  // The underlying input component from the deprecated design system does not reliably
  // re-render when its `value` prop changes, causing a "stale UI" bug.
  //
  // Calling watch() creates a subscription that forces this wrapper component to
  // re-render on every change, ensuring the UI stays in sync with the form state.
  // This is a targeted workaround for the external library's rendering issue.
  watch(FIELD_NAME)

  return (
    <Controller
      name={FIELD_NAME}
      control={control}
      render={({ field }) => (
        <TextField
          label={i18n.t('expenses_v2.forms.fields.reference.label')}
          mandatory={isFieldMandatory}
          value={field.value ?? ''}
          onChange={(value) => field.onChange(value)}
          placeholder={i18n.t('expenses_v2.forms.fields.reference.placeholder')}
          error={castError(errors?.internalReference)}
          readonly={isFieldReadOnly}
        />
      )}
    />
  )
}

export default withCustomizationFields(withFieldPermissions(InternalReferenceField, FIELD_NAME))
